<template>
  <div :class="['lee-count-down',thesize]" :style="{'--color': color}">
    <div class="pai" v-for="(item,xh) in lens(diffDay)"><span class="num">{{getday(xh)}}</span></div>
    <div class="zi">天</div>
    <div class="pai" v-for="(item,xh) in lens(diffHou)"><span class="num">{{gethou(xh)}}</span></div>
    <div class="zi">时</div>
    <div class="pai" v-for="(item,xh) in lens(diffMin)"><span class="num">{{getmin(xh)}}</span></div>
    <div class="zi">分</div>
    <div class="pai" v-for="(item,xh) in lens(diffSec)"><span :class="['num',{down:getsec(xh)!=getsec(xh)}]">{{getsec(xh)}}</span></div>
    <div class="zi">秒</div>
  </div>
</template>
<script>
export default {
    name: 'LeeCountDown',
    inheritAttrs: false,
    data() {
        return {
            thesize:'',
            diffDay: '0',
            diffHou: '0',
            diffMin: '0',
            diffSec: '0',
            diff: 0
        }
    },
     watch: {
        size: {
            immediate: true,
            handler(value) {
                let types = ['s', 'm', 'l']
                let fi = types.filter(function(el) {
                    return el.indexOf(value) > -1;
                })
                if (fi.length < 1) {
                    this.thesize = "m"
                } else {
                    this.thesize = value
                }
            }
        }
    },
    created() {
        let endDate = new Date(this.endDate).getTime();
        let beginDate = new Date().getTime();
        this.diff = Math.floor((endDate - beginDate) / 1000);
        this.toDataTime()
        //定时器
        setInterval(() => {
            this.diff--;
            this.toDataTime()
        }, 1000)
    },
    methods: {
        toDataTime() {
            this.diffDay = Math.floor(this.diff / (60 * 60 * 24));
            this.diffHou = Math.floor((this.diff / (60 * 60))) - (this.diffDay * 24);
            this.diffMin = Math.floor(this.diff / (60)) - (this.diffDay * 24 * 60) - (this.diffHou * 60);
            this.diffSec = Math.floor(this.diff) - (this.diffDay * 24 * 60 * 60) - (this.diffHou * 60 * 60) - (this.diffMin * 60);
            if (this.diffDay < 10) this.diffDay = "0" + this.diffDay;
            if (this.diffHou < 10) this.diffHou = "0" + this.diffHou;
            if (this.diffMin < 10) this.diffMin = "0" + this.diffMin;
            if (this.diffSec < 10) this.diffSec = "0" + this.diffSec;
        },
        getday(xh) {
            return String(this.diffDay).substr(xh, 1)
        },
        gethou(xh) {
            return String(this.diffHou).substr(xh, 1)
        },
        getmin(xh) {
            return String(this.diffMin).substr(xh, 1)
        },
        getsec(xh) {
            return String(this.diffSec).substr(xh, 1)
        },
        lens(text) {
            return String(text).length
        }
    },
    props: {
        endDate: {
            type: String,
            default: '2021/10/01 00:00:00' //默认default
        },
        size: {
            type: String,
            default: 'm' //默认default
        },
        color: {
            type: String,
            default: '#000' //默认default
        }

    }
};
</script>
<style>
.lee-count-down {
  display: flex;
  overflow: hidden;
  font-size: 16px;
  color: var(--color);
}

.lee-count-down.s {
  font-size: 12px;
}

.lee-count-down.l {
  font-size: 20px;
}

.lee-count-down .pai {
  display: flex;
  padding: 0 3px;
}

.lee-count-down span.num {
  border-radius: 3px;
  background: var(--color);
  color: #fff;
  transition: .3s;
  padding: 0 3px;
}
.lee-count-down span.num.down{transform: translateY(100%);}
</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeCountDown.vue